import classNames from 'classnames';
import React from 'react';

// eslint-disable-next-line react/require-default-props
function LoadingSmall({ loading, className }: { loading: boolean, className?: string }) {
  return loading ? (
    <div
      className={classNames('loader is-loading with-accent-border-color', className)}
    />
  )
    : (
      <div
        className={className}
        style={{
          width: 16,
          height: 16,
        }}
      />
    );
}

export default React.memo(LoadingSmall);
